import { PageId } from 'constants/pages'

export const enum PageIdStylioCapsule3 {
  AGE_CAPSULE3 = PageId.AGE_CAPSULE3,
  URGE_CAPSULE3 = PageId.URGE_CAPSULE3,
  HAIR_COLOR_CAPSULE3 = PageId.HAIR_COLOR_CAPSULE3,
  EYES_COLOR_CAPSULE3 = PageId.EYES_COLOR_CAPSULE3,
  JEWELRY_CAPSULE3 = PageId.JEWELRY_CAPSULE3,
  BODY_SHAPE_CAPSULE3 = PageId.BODY_SHAPE_CAPSULE3,
  STYLIO_TO_HELP_CAPSULE3 = PageId.STYLIO_TO_HELP_CAPSULE3,
  TALL_CAPSULE3 = PageId.TALL_CAPSULE3,
  WEIGHT_CAPSULE3 = PageId.WEIGHT_CAPSULE3,
  URGE_2_CAPSULE3 = PageId.URGE_2_CAPSULE3,
  SHOPPING_CAPSULE3 = PageId.SHOPPING_CAPSULE3,
  STYLE_MOST_MATTERS_CAPSULE3 = PageId.STYLE_MOST_MATTERS_CAPSULE3,
  FEEL_ABOUT_CAPSULE3 = PageId.FEEL_ABOUT_CAPSULE3,
  PERCENTAGE_CAPSULE3 = PageId.PERCENTAGE_CAPSULE3,
  FAVORITE_COLORS_CAPSULE3 = PageId.FAVORITE_COLORS_CAPSULE3,
  LIKE_OR_DISLIKE_CAPSULE3 = PageId.LIKE_OR_DISLIKE_CAPSULE3,
  LIKE_OR_DISLIKE_11_CAPSULE3 = PageId.LIKE_OR_DISLIKE_11_CAPSULE3,
  LIKE_OR_DISLIKE_12_CAPSULE3 = PageId.LIKE_OR_DISLIKE_12_CAPSULE3,
  LIKE_OR_DISLIKE_13_CAPSULE3 = PageId.LIKE_OR_DISLIKE_13_CAPSULE3,
  LIKE_OR_DISLIKE_14_CAPSULE3 = PageId.LIKE_OR_DISLIKE_14_CAPSULE3,
  LIKE_OR_DISLIKE_15_CAPSULE3 = PageId.LIKE_OR_DISLIKE_15_CAPSULE3,
  LIKE_OR_DISLIKE_16_CAPSULE3 = PageId.LIKE_OR_DISLIKE_16_CAPSULE3,
  LIKE_OR_DISLIKE_17_CAPSULE3 = PageId.LIKE_OR_DISLIKE_17_CAPSULE3,
  LIKE_OR_DISLIKE_18_CAPSULE3 = PageId.LIKE_OR_DISLIKE_18_CAPSULE3,
  LIKE_OR_DISLIKE_19_CAPSULE3 = PageId.LIKE_OR_DISLIKE_19_CAPSULE3,
  STYLES_FEEL_LIKE_YOU_CAPSULE3 = PageId.STYLES_FEEL_LIKE_YOU_CAPSULE3,
  URGE_4_CAPSULE3 = PageId.URGE_4_CAPSULE3,
  BRAND_CAPSULE3 = PageId.BRAND_CAPSULE3,
  FIND_NEW_CLOTHES_CAPSULE3 = PageId.FIND_NEW_CLOTHES_CAPSULE3,
  NOTHING_TO_WEAR_CAPSULE3 = PageId.NOTHING_TO_WEAR_CAPSULE3,
  OLD_CLOTHES_CAPSULE3 = PageId.OLD_CLOTHES_CAPSULE3,
  COMBINE_CLOTHES_CAPSULE3 = PageId.COMBINE_CLOTHES_CAPSULE3,
  OPTIMIZE_BUDGET_CAPSULE3 = PageId.OPTIMIZE_BUDGET_CAPSULE3,
  URGE_3_CAPSULE3 = PageId.URGE_3_CAPSULE3,
  PREPARE_FLOW_CAPSULE3 = PageId.PREPARE_FLOW_CAPSULE3,
  EMAIL_CAPSULE3 = PageId.EMAIL_CAPSULE3,
  EMAIL_CONSENT_CAPSULE3 = PageId.EMAIL_CONSENT_CAPSULE3,
  SUBSCRIPTIONS_CAPSULE3 = PageId.SUBSCRIPTIONS_CAPSULE3,
  CANCEL_OFFER_CAPSULE3 = PageId.CANCEL_OFFER_CAPSULE3,
  SUB_UPSELL_CAPSULE3 = PageId.SUB_UPSELL_CAPSULE3,
  UPSELL_CAPSULE3 = PageId.UPSELL_CAPSULE3,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPSULE3 = PageId.DOWNLOAD_CAPSULE3,
}
